import { call, put, select } from 'redux-saga/effects';
import { createSession } from '../../api';
import { doSaveSession } from '../actions';
import { handleFetchSubscription } from './subscription';
import { postMessageSender } from '../../lib/postMessager';
import { handleRequestPixSessionToken } from './pixToken';
import { getSubscription } from '../selectors';

export function* handleCreateSession(action) {
  const { authCode } = action;
  try {
    const { data } = yield call(createSession, authCode);
    yield put(doSaveSession(data.token));
    yield call(handleFetchSubscription);

    const subscription = yield select(getSubscription);
    if (process.env.REACT_APP_PIX_ENABLED === 'true' &&
      subscription.status === 'ATIVA' && subscription.pagamento.status !== 'SUCESSO') {
      yield call(handleRequestPixSessionToken);
    }
  } catch (e) {
    postMessageSender({
      action: 'startFailed',
      reason: e.response ? e.response.statusText : '',
    });
  }
}
